import './style.css';
import { Game } from './core/Game';

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  import('virtual:pwa-register').then(({ registerSW }) => registerSW({ immediate: true })).catch(() => {});
}

const app = document.getElementById('app')!;
const game = new Game(app);
game.start().catch(err => {
  console.error('Game failed to start', err);
  const msg = document.createElement('pre');
  msg.style.color = '#ff6b6b';
  msg.style.padding = '20px';
  msg.style.fontSize = '14px';
  msg.textContent = String(err?.stack ?? err);
  app.appendChild(msg);
});
